"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CheckBanner;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/styles");
const variables_1 = __importDefault(require("../../styles/variables"));
const Text_1 = __importDefault(require("../Text"));
const Icon_1 = require("../Icon");
const clsx_1 = __importDefault(require("clsx"));
const useStyles = (0, styles_1.makeStyles)({
    wrapper: {
        borderRadius: variables_1.default.spacing(1),
        backgroundColor: variables_1.default.colors.base.background,
        padding: `${variables_1.default.spacing(1)} ${variables_1.default.spacing(2)}`,
        color: variables_1.default.colors.text.default,
    },
    item: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: variables_1.default.spacing(0.5),
        marginLeft: variables_1.default.spacing(0.3),
    },
    checkIcon: {
        color: variables_1.default.colors.base.success,
        fontSize: variables_1.default.spacing(2.5),
    },
    closeIcon: {
        color: variables_1.default.colors.icon.default,
        fontSize: variables_1.default.spacing(2.5),
    },
    icon: { marginRight: variables_1.default.spacing(1.5) },
    header: { marginBottom: variables_1.default.spacing(1) },
});
function CheckBanner({ items, className, header, ...rest }) {
    const classes = useStyles();
    const Icon = (icon, className, outline = false) => outline ? (react_1.default.createElement(Icon_1.OutlinedIcon, { icon: icon, className: (0, clsx_1.default)(classes.icon, className) })) : (react_1.default.createElement(Icon_1.RegularIcon, { icon: icon, className: (0, clsx_1.default)(classes.icon, className) }));
    const checkIcon = Icon('check_circle', classes.checkIcon);
    const closeIcon = Icon('close', classes.closeIcon, true);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(className, classes.wrapper), ...rest },
        header && (react_1.default.createElement("div", { className: classes.header },
            react_1.default.createElement(Text_1.default, null, header))),
        items.map(({ title, checked }) => (react_1.default.createElement("div", { key: title, className: classes.item },
            checked ? checkIcon : closeIcon,
            react_1.default.createElement(Text_1.default, null, title))))));
}
